type SwitchProps = {
  handleSwitch?: (isChecked: boolean) => void;
  isChecked: boolean;
};

export const Switch = ({ handleSwitch, isChecked }: SwitchProps) => {
  const handleChange = () => {
    const newCheckedState = !isChecked;
    handleSwitch && handleSwitch(newCheckedState);
  };

  return (
    <label className="tw-relative tw-inline-block tw-w-14 tw-h-8">
      <input
        type="checkbox"
        className="tw-absolute tw-w-0 tw-h-0 tw-opacity-0"
        checked={isChecked}
        onChange={handleChange}
      />

      <span
        className={`${
          isChecked ? 'tw-bg-[#99a5c1]' : 'tw-bg-gray-300'
        } tw-relative tw-block tw-w-14 tw-h-6 tw-rounded-full tw-transition-all`}
      >
        <span
          className={`${
            isChecked
              ? 'tw-translate-x-6 tw-bg-[#001E64]'
              : 'tw-bg-white tw-shadow-md'
          } tw-absolute tw-top-1/2 tw-transform tw--translate-y-1/2 tw-w-8 tw-h-8 tw-rounded-full tw-transition-transform`}
        />
      </span>
    </label>
  );
};
